import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AppConstants } from 'src/app/commons/app-constants';

/** Custom-Made / re-saw Phase 2 — least-wastage lot ranking. A plain global flag, same shape as
 *  BetaService: purely a client-side sort/recommendation on top of Phase 1.5's lot lists, not a
 *  gated capability, so no SUPER_ADMIN/ROOT bypass is needed (unlike InventoryModuleService/
 *  ProcessModuleService) — off means everyone, including elevated roles, just sees the
 *  unranked list exactly as Phase 1.5 shipped it. */
@Injectable({ providedIn: 'root' })
export class CustomMadeAutoSuggestService {
  private readonly enabledSubject = new BehaviorSubject<boolean>(false);
  readonly enabled$ = this.enabledSubject.asObservable();

  private loaded = false;

  constructor(private http: HttpClient) {}

  get enabled(): boolean {
    return this.enabledSubject.value;
  }

  load(): void {
    if (this.loaded) return;
    this.loaded = true;
    this.http
      .get<{ customMadeAutoSuggestEnabled: boolean }>(`${AppConstants.API_URL}api/v1/app/custom-made-auto-suggest`)
      .subscribe({
        next: (res) => this.enabledSubject.next(res.customMadeAutoSuggestEnabled),
        error: () => { /* silently ignore — ranking stays off */ },
      });
  }

  refresh(): void {
    this.loaded = false;
    this.load();
  }

  setFromBootstrap(enabled: boolean): void {
    this.loaded = true;
    this.enabledSubject.next(enabled);
  }
}
